<template>
  <div class="login-form">
    <div class="form-item text-center forget-title">
      <span>Нууц үг сэргээх</span>
      <p>Нууц үгээ шинэчлэх кодыг хэрхэн авах вэ?</p>
    </div>
    <div class="form-item forget-form">
      <div class="forget-checkbox" v-for="user in userdata" :key="user.id">
        <b-form-checkbox
          :id="user.id"
          :value="user.typeValue"
          v-model="selectedValue"
        >
          <p class="forget-user-phone">{{ user.typeValue }}</p>
          <p v-if="user.type == `Phone`">утасны дугаар</p>
          <p v-else>имэйл хаяг руу илгээх</p>
        </b-form-checkbox>
      </div>
    </div>
    <div class="forget-form forget-btn">
      <input
        type="submit"
        class="btn forget-btn-inner"
        value="ИЛГЭЭХ"
        @click="sendData"
        :Disabled="isDisabled"
      />
      <span class="btn forget-btn-inner" @click="back">БОЛИХ</span>
    </div>
    <div class="form-item form-error-out" v-if="error">
      <div class="form-error">
        <div class="error-icon">
          <img src="@/assets/icon/error.png" alt="" />
        </div>
        <div class="error-message">
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: {
    userdata: Array,
    userToken: String,
  },
  data() {
    return {
      selectedValue: "",
      errorMessage: "",
      error: false,
      isDisabled: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    //add step
    stepadd() {
      this.$emit("addStep");
    },
    //sendUserData
    sendData() {
      if (this.selectedValue.length != 0 && this.selectedValue != false) {
        this.isDisabled = true;
        this.$insProgress.start();
        const str = this.userdata.find(
          (d) => d.typeValue === this.selectedValue
        );
        var typeValue = str.realValue;
        var type = str.type;
        var cardHolderKey = str.cardHolderKey;
        var tokenId = str.tokenId;
        this.$cardApi
          .post(
            "/auth/recover/password",
            {
              type,
              typeValue,
              systemId: "NominApp",
              tokenId,
              cardHolderKey,
            },
            {
              headers: {
                "Accept-Language": "en-US",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((response) => {
            if (response.data === true) {
              this.$emit("sendedValue", str);
              this.stepadd();
              this.$insProgress.finish();
              this.isDisabled = false;
            } else if (response.data.status === 100) {
              this.errorMessage = response.data.message;
              this.error = true;
              this.$insProgress.finish();
              this.isDisabled = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.errorMessage = error.response.data.message;
            this.error = true;
            // this.RedirectLogin();
            // this.$auth.destroyToken();
            // this.$auth.removeMe();
            // this.$router.push({ name: "login" });
          });
      } else {
        this.errorMessage = "Та сонголтоо хийнэ үү ?";
        this.error = true;
        this.selectedValue = "";
      }
    },
    //back to Login
    back() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>
